const translations = {
    customers: 'Customers',
    import: 'Import',
    newCustomer: 'New Customer'
};

export default translations;
